<template>
    <div id="prestataires" :class="!totalProviders && !firstLoading && 'bg-dark'">
        <div class="app-container position-relative mb-5" v-show="!$global.loading">

            <div v-if="!totalProviders && !firstLoading">

                <div class="d-flex flex-column justify-content-center align-items-center text-center gap-30"
                     id="init-container">
                    <h4 class="text-white">Vous n'avez pas encore ajouté de prestataire....
                    </h4>

                    <div class="d-flex justify-content-center align-items-center gap-30">
                        <component
                          :is="!hasCreateProviderModule ? 'span' : 'router-link'"
                          class="init-action" :class="!hasCreateProviderModule && 'disable'"
                                     to="/create-provider" >
                            <div class="d-flex flex-column justify-content-center align-items-center gap-20 p-5">
                                <v-icon class="init-action-icon" large>mdi-plus</v-icon>
                                <h5>Créer une fiche</h5>
                            </div>
                        </component>
                        <div class="init-action"
                             @click="importDialog = true"
                             v-if="['APIDAE', 'TOURINSOFT', 'NO_SIT'].includes(account.tis_type.code)">
                            <div class="d-flex flex-column justify-content-center align-items-center gap-20 p-5">
                                <v-icon class="init-action-icon" large>arrow_upward</v-icon>
                                <h5>
                                    Importer mes prestataires
                                    <span v-if="account.tis_type.code === 'APIDAE'">depuis Apidae</span>
                                    <span v-else-if="account.tis_type.code === 'TOURINSOFT'">depuis Tourinsoft</span>
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="d-flex justify-content-between mt-5">

                    <div class="page-title">
                        <span class="breadcrumb-link">
                            <v-icon class="breadcrumb-link-icon">reorder</v-icon> Mes prestataires <span
                          v-if="total && !firstLoading">({{ total }})</span>
                        </span>
                    </div>

                    <div class="d-flex actions-list">
                        <v-tooltip slot="append-outer" bottom v-if="!isAccountConfigured">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="warning">warning</v-icon>
                            </template>
                            <span>Votre compte ne dispose pas de la configuration requise pour programmer une
                                campagne.</span>
                        </v-tooltip>

                        <v-menu bottom transition="slide-y-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="default-button" v-on="on" :disabled="!selectedProviders.length || !total">
                                    Sur la sélection
                                    <v-icon>arrow_drop_down</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="prepareCmajCampaign"
                                             :disabled="!selectedProviders.length || !isAccountConfigured || !isCmajAvailable">
                                    <v-list-item-title>
                                        Programmer une campagne de mise à jour
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="prepareCadhCampaign"
                                             :disabled="!selectedProviders.length || !isAccountConfigured || !isCadhAvailable">
                                    <v-list-item-title>
                                        Programmer une campagne d'adhésion
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="openTagModal" :disabled="!selectedProviders.length">
                                    <v-list-item-title>
                                        Appliquer un tag
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="openRemoveTagModal" :disabled="!selectedProviders.length">
                                    <v-list-item-title>
                                        Retirer un tag
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="checkProConnexionLinks" :disabled="!selectedProviders.length">
                                    <v-list-item-title>
                                        Supprimer les fiches
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>

                        <v-menu bottom transition="slide-y-transition" offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn class="default-button" v-on="on" :disabled="!total">
                                    Actions
                                    <v-icon>arrow_drop_down</v-icon>
                                </v-btn>
                            </template>

                            <v-list>
                                <v-list-item @click="createFiche" :disabled="!hasCreateProviderModule">
                                    <v-list-item-title>
                                        Créer une fiche
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="importDialog = true" v-if="getTisTypeLabel()">
                                    <v-list-item-title>
                                        Importer des fiches depuis {{ getTisTypeLabel() }}
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="prepareExport" :disabled="loadingExport || total === 0">
                                    <v-list-item-title>
                                        Exporter
                                        <div class="badge bg-primary text-white">
                                            <span v-if="selectAll || !selectedProviders.length">{{ total }}</span>
                                            <span v-else>{{ selectedProviders.length }}</span>
                                        </div>
                                    </v-list-item-title>
                                </v-list-item>

                                <v-list-item @click="deleteRemovedSitProviders"
                                             v-if="account.tis_type.code === 'APIDAE'">
                                    <v-list-item-title>
                                        Voir mes fiches non présentes sur Apidae
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>

                <div class="mt-5 mb-3">

                    <v-card>
                        <v-card-title>
                            <filters></filters>

                            <div v-if="selectedProviders.length === options.itemsPerPage"
                                 class="text-center w-100 mt-4 presta-count">

                                <div v-if="!selectAll" class="d-flex justify-content-center">
                                    <div class="mt-auto mb-auto">
                                        Les <b>{{ selectedProviders.length }}</b> prestataires de cette page sont
                                        sélectionnés.
                                    </div>

                                    <div>
                                        <v-btn color="primary" text @click="selectAll = true">
                                            Sélectionner les {{ total }} prestataires
                                        </v-btn>
                                    </div>
                                </div>

                                <div v-else class="d-flex justify-content-center">
                                    <div class="mt-auto mb-auto">
                                        Les <b>{{ total }}</b> prestataires de cette recherche sont sélectionnés.
                                    </div>

                                    <div>
                                        <v-btn color="primary" text @click="clearSelect">
                                            Annuler la sélection
                                        </v-btn>
                                    </div>
                                </div>

                            </div>
                        </v-card-title>
                        <v-data-table :headers="headers" :items="providers" show-select :loading="loading"
                                      v-model="selectedProviders" :items-per-page="options.itemsPerPage"
                                      no-data-text="Aucun prestataires" class="elevation-1" :server-items-length="total"
                                      :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :options.sync="options"
                                      :footer-props="{
                                itemsPerPageAllText: 'Tous',
                                itemsPerPageText: 'Prestataire par page',
                                itemsPerPageOptions: [10, 20, 50, 1000]
                            }">

                            <template v-slot:item.name="{ item }">
                                <div v-if="item.name === null">
                                    <router-link :to="'/summary/' + encodeUri(item.id)">-</router-link>
                                </div>
                                <div v-else>
                                    <router-link :to="'/summary/' + encodeUri(item.id)">{{ item.name }}</router-link>
                                </div>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-menu bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon v-on="on">
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>

                                    <v-list>
                                        <v-tooltip bottom v-if="item.apidae_selections_count > 0">
                                            <template v-slot:activator="{ on }">
                                          <span v-on="on">
                                          <v-list-item @click="prepareUpdateContact(item)"
                                                       :disabled="item.apidae_selections_count > 0">
                                            <v-list-item-title>
                                              <v-icon color="primary"
                                                      :disabled="item.apidae_selections_count > 0">edit</v-icon> Modifier le destinataire
                                            </v-list-item-title>
                                          </v-list-item>
                                            </span>
                                            </template>
                                            <div>
                                                Les coordonnées du contact ne sont pas modifiables, car ce dernier est
                                                lié à une sélection.<br>
                                                Il sera modifié si vous éditez le contact sur Apidae. Le contact sur
                                                Dahub sera mis à jour au
                                                moyen du temps réel Apidae.
                                            </div>
                                        </v-tooltip>

                                        <v-list-item @click="prepareUpdateContact(item)" v-else>
                                            <v-list-item-title>
                                                <v-icon color="primary">edit</v-icon>
                                                Modifier le destinataire
                                            </v-list-item-title>
                                        </v-list-item>

                                        <v-list-item @click="deleteProvider(item)">
                                            <v-list-item-title>
                                                <v-icon color="error">delete</v-icon>
                                                Supprimer le prestataire
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>
                        </v-data-table>
                    </v-card>

                </div>
            </div>
        </div>

        <div id="loading-export" v-if="loadingExport">
            <div class="p-5 gap-50">
                <v-progress-circular class="progressbar text-accent" indeterminate size="40" width="4">
                </v-progress-circular>
                <p class="m-0 p-0 text-primary">Nous sommes en train de récupérer vos prestataires, cela peut prendre
                    quelques secondes...</p>
            </div>
        </div>

        <import-apidae :import-dialog="importDialog" v-if="account.tis_type.code === 'APIDAE'"></import-apidae>
        <import-tourinsoft :import-dialog="importDialog" v-else-if="account.tis_type.code === 'TOURINSOFT'"></import-tourinsoft>
        <import-dahub :import-dialog="importDialog" v-else-if="account.tis_type.code === 'NO_SIT'"></import-dahub>

        <update-receiver-modale :edit-contact-modal="editContactModal" :selected-contact="selectedContact"
                                :selected-provider="selectedProvider">
        </update-receiver-modale>

        <v-dialog v-model="tagModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Ajout de tags</span>
                </v-card-title>

                <v-card-text>
                    <v-combobox outlined label="Tags" multiple chips small-chips :items="tags" item-text="name"
                                @blur="searchTag = ''" deletable-chips :hide-no-data="!searchTag"
                                :search-input.sync="searchTag"
                                v-model="selectedModalTags" return-object>
                    </v-combobox>
                </v-card-text>

                <v-card-actions style="padding: 0 24px 10px">
                    <div class="text-right w-100 mb-4 ml-4">
                        <v-btn color="error" class="mr-4" @click="tagModal = false">Annuler</v-btn>
                        <v-btn class="default-button" @click="tagProviders" :disabled="selectedModalTags.length === 0">
                            Taguer mes {{ providerIds.length }} fiches
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="removeTagModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Retirer des tags</span>
                </v-card-title>

                <v-card-text>
                    <v-select outlined label="Tags" multiple chips small-chips :items="availableDeletetags"
                              item-text="name" deletable-chips v-model="selectedModalTags" return-object>
                    </v-select>
                </v-card-text>

                <v-card-actions style="padding: 0 24px 10px">
                    <div class="text-right w-100 mb-4 ml-4">
                        <v-btn color="error" class="mr-4" @click="removeTagModal = false">Annuler</v-btn>
                        <v-btn class="default-button" @click="unTagProviders">
                            Détaguer mes {{ providerIds.length }} fiches
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteProvidersModal" persistent max-width="1000px">
            <v-card>
                <v-card-title>
                    <div class="d-flex w-100 justify-content-between align-items-center">
                        <span class="headline">Fiches Dahub inexistantes sur
                            {{ account.tis_type.code === "APIDAE" ? "Apidae" : "Tourinsoft" }} ({{
                                providersToDelete.length
                            }})</span>
                        <v-icon @click="deleteProvidersModal = false">clear</v-icon>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-simple-table height="calc(100vh - 400px)" fixed-header>
                        <thead>
                        <tr>
                            <th class="text-left">Nom</th>
                            <th class="text-left">Catégorie</th>
                            <th class="text-left">Commune</th>
                            <th class="text-left">Destinataire</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="provider in providersToDelete" :key="provider.id">
                            <td>{{ provider.name }}</td>
                            <td>{{ provider.category }}</td>
                            <td>{{ provider.commune }}</td>
                            <td>{{ provider.email }}</td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions style="padding: 0 24px 10px">
                    <div class="text-right w-100 mb-4 ml-4">
                        <v-btn class="mr-4" @click="deleteProvidersModal = false">Annuler</v-btn>
                        <v-btn class="default-button" :disabled="!providersToDelete.length"
                               @click="deleteProvidersToRemove">
                            Supprimer mes {{ providersToDelete.length }} fiches
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="deleteProConnexionModal" persistent max-width="1000px">
            <v-card>
                <v-card-title>
                    <div class="d-flex w-100 justify-content-between align-items-center">
                        <span class="headline">Fiches liées à des demandes de connexions sur Uska</span>
                        <v-icon @click="deleteProConnexionModal = false">clear</v-icon>
                    </div>
                </v-card-title>

                <v-card-text>
                    <v-alert type="warning" text class="mt-5 mb-5 form-container mr-auto ml-auto" border="right"
                             colored-border>
                        <p>
                            Les fiches liées à des demandes de connexions sur Uska ne peuvent pas être supprimées.
                        </p>
                    </v-alert>

                    <v-simple-table height="calc(100vh - 400px)" fixed-header>
                        <thead>
                        <tr>
                            <th class="text-left">Nom</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="provider in proConnexions" :key="provider.id">
                            <td>{{ provider.name }}</td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-card-text>

                <v-card-actions style="padding: 0 24px 10px">
                    <div class="text-right w-100 mb-4 ml-4">
                        <v-btn class="mr-4" @click="deleteProConnexionModal = false">Annuler</v-btn>
                        <v-btn class="default-button" :disabled="!deleteNumber"
                               @click="deleteProviders">
                            Supprimer mes {{ deleteNumber }} fiches
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import _ from "lodash-es"
import ImportApidae from "./ImportApidae"
import Confirm from "../tools/Confirm"
import { mapState, mapMutations } from "vuex"
import Filters from "./Filters"
import UpdateReceiverModale from "./UpdateReceiverModale"
import ImportTourinsoft from "./ImportTourinsoft"
import ImportDahub from "./ImportDahub.vue"

export default {
    name: "Provider",
    components: { ImportTourinsoft, UpdateReceiverModale, Filters, Confirm, ImportApidae, ImportDahub, },
    data() {
        return {
            headers: [
                {
                    text: "Nom",
                    value: "name",
                },
                {
                    text: "Catégorie",
                    value: "category",
                },
                {
                    text: "Commune",
                    value: "commune",
                },
                {
                    text: "Destinataire",
                    value: "email",
                },
                {
                    text: "Actions",
                    value: "actions",
                },
            ],
            providers: [],
            selectedProviders: [],
            importDialog: false,
            total: 1,
            totalProviders: 0,
            loading: false,
            options: { itemsPerPage: 10, page: 1 },
            selectAll: false,
            editContactModal: false,
            selectedContact: null,
            selectedProvider: [],
            apiUrl: process.env.VUE_APP_API_URL,
            config: null,
            tagModal: false,
            removeTagModal: false,
            selectedModalTags: [],
            availableDeletetags: [],
            sortBy: "name",
            sortDesc: false,
            providerIds: [],
            searchTag: null,
            loadingExport: false,
            deleteProvidersModal: false,
            deleteProConnexionModal: false,
            providersToDelete: [],
            proConnexions: [],
            firstLoading: true,
        }
    },
    methods: {
        ...mapMutations('providerFilter', ['setCanSearch']),
        getProviders: _.debounce(function() {
            let sortBy = Array.isArray(this.sortBy) ? this.sortBy[0] : this.sortBy
            let sortDesc = Array.isArray(this.sortDesc) ? this.sortDesc[0] : this.sortDesc

            let payload = {
                perPage: this.options.itemsPerPage,
                currentPage: this.options.page,
                search: this.search,
                emailSearch: this.emailSearch,
                categories: this.selectedCategories,
                communes: this.selectedCommunes,
                tourismSectors: this.selectedTourismSectors,
                tags: this.selectedTags,
                states: this.selectedWebFormStates,
                sortBy: sortBy,
                sortDesc: sortDesc,
            }

            this.loading = true

            this.$http.post("auth/providers", payload).then(res => {
                this.providers = Object.values(res.body.data.providers.data)
                this.currentPage = res.body.data.providers.from
                this.total = res.body.data.providers.total

                this.selectedProviders = []

                this.importDialog = false
                this.loading = false
                this.firstLoading = false
                this.setCanSearch(true)
            })
        }, 500),
        clearSelect() {
            this.selectedProviders = []
            this.selectAll = false
        },
        prepareCmajCampaign() {
            this.prepareCampaign()

            this.$router.push("/campaign/cmaj/create")
        },
        prepareCadhCampaign() {
            this.prepareCampaign()

            this.$router.push("/campaign/cadh/create")
        },
        async prepareCampaign() {
            let providerIds = await this.getProviderIds()

            localStorage.setItem("providerIds", JSON.stringify(providerIds))

            this.$global.loading = false
        },
        async getProviderIds(nothingMeanAll = false) {
            let providerIds = []

            if (!this.selectAll && (!nothingMeanAll || this.selectedProviders.length)) {
                providerIds = this.selectedProviders.map(provider => provider.id)
            } else {
                let payload = {
                    perPage: this.options.itemsPerPage,
                    currentPage: this.options.page,
                    search: this.search,
                    emailSearch: this.emailSearch,
                    categories: this.selectedCategories,
                    communes: this.selectedCommunes,
                    tourismSectors: this.selectedTourismSectors,
                    tags: this.selectedTags,
                    states: this.selectedWebFormStates,
                    onlyIds: true,
                }

                let res = await this.$http.post("auth/providers", payload)

                providerIds = res.body.data.ids

                this.$global.loading = false
            }

            return providerIds
        },
        prepareUpdateContact(provider) {
            this.editContactModal = true
            this.selectedContact = provider.email
            this.selectedProvider = provider
        },
        slugify(str) {
            str = str.replace(/^\s+|\s+$/g, "")
            str = str.toLowerCase()

            let from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;"
            let to = "aaaaeeeeiiiioooouuuunc------"

            for (let i = 0, l = from.length; i < l; i++) {
                str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i))
            }

            return str.replace(/[^a-z0-9 -]/g, "")
              .replace(/\s+/g, "-")
              .replace(/-+/g, "-")
        },
        deleteProvider(provider) {
            this.$refs.confirm.open("Attention",
              "Vous allez supprimer le prestataire " + provider.name +
              " (" + provider.category + ")." +
              " Êtes-vous sûr de vouloir le supprimer ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    this.$http.delete("auth/providers/" + provider.id).then(res => {
                        this.$global.loading = false

                        this.getProviders()
                    })
                }
            })
        },
        async setProviderIdsFromSelection() {
            if (this.selectAll && this.selectedProviders.length >= this.options.itemsPerPage) {
                let providerIds = await this.getProviderIds()

                this.$global.loading = false

                this.providerIds = providerIds
            } else {
                this.providerIds = this.selectedProviders.map(provider => provider.id)
            }

            // écarte les pros liés à des demandes de connexions (non supprimables)
            let proConnexionIds = this.proConnexions.map(provider => provider.id)

            this.providerIds = this.providerIds.filter(id => {
                return proConnexionIds.indexOf(id) < 0
            })
        },
        async checkProConnexionLinks() {
            this.proConnexions = []

            await this.setProviderIdsFromSelection()

            this.$refs.confirm.open("Attention",
              "Vous allez supprimer <b>" + this.providerIds.length +
              " fiches</b>. Êtes-vous sûr de vouloir les supprimer ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    let payload = {
                        providerIds: this.providerIds,
                    }

                    this.$http.post("auth/providers/provider-pro-connexions", payload).then(res => {
                        this.$global.loading = false

                        this.proConnexions = res.body.data.providersWithProConnexions

                        if (this.proConnexions && this.proConnexions.length) {
                            this.deleteProConnexionModal = true
                        } else {
                            this.deleteProviders()
                        }
                    })
                }
            })

        },
        async deleteProviders() {
            this.setProviderIdsFromSelection()

            this.$global.loading = true

            let payload = {
                ids: this.providerIds,
            }

            this.$http.post("auth/providers/delete-ids", payload).then(res => {
                this.$global.loading = false

                this.getProviders()

                this.deleteProvidersModal = false
                this.deleteProConnexionModal = false
            })
        },
        deleteProvidersToRemove() {
            this.$refs.confirm.open("Attention",
              "Vous allez supprimer <b>" + this.providersToDelete.length +
              " fiches</b>. Êtes-vous sûr de vouloir les supprimer ?",
              { color: "red" }).then((confirm) => {
                if (confirm) {
                    this.$global.loading = true

                    let payload = {
                        ids: this.providersToDelete.map(provider => provider.id),
                    }

                    this.$http.post("auth/providers/delete-ids", payload).then(res => {
                        this.$global.loading = false

                        this.deleteProvidersModal = false
                    })
                }
            })
        },
        deleteRemovedSitProviders() {
            this.$global.loading = true

            this.$http.get("auth/account/removed-provider-ids").then(res => {
                this.providersToDelete = res.body.data.providersToDelete

                this.deleteProvidersModal = true
                this.$global.loading = false
            })
        },
        createFiche() {
            this.$router.push("/create-provider")
        },
        async openTagModal() {
            if (this.selectAll && this.selectedProviders.length >= this.options.itemsPerPage) {
                let providerIds = await this.getProviderIds()

                this.$global.loading = false

                this.providerIds = providerIds
            } else {
                this.providerIds = this.selectedProviders.map(provider => provider.id)
            }

            this.selectedModalTags = []
            this.tagModal = true
        },
        async openRemoveTagModal() {
            if (this.selectAll && this.selectedProviders.length >= this.options.itemsPerPage) {
                let providerIds = await this.getProviderIds()

                this.$global.loading = false

                this.providerIds = providerIds
            } else {
                this.providerIds = this.selectedProviders.map(provider => provider.id)
            }

            this.availableDeletetags = await this.getTagsFromProviders()
            this.removeTagModal = true
        },
        encodeUri(id) {
            return btoa(id)
        },
        tagProviders() {
            setTimeout(() => {
                let newTags = []
                let tags = []

                this.selectedModalTags.forEach(tag => {
                    if (typeof tag === "object") {
                        tags.push(tag)
                    } else {
                        newTags.push(tag)
                    }
                })

                let payload = {
                    providerIds: this.providerIds,
                    tags: tags,
                    newTags: newTags,
                }

                this.$global.loading = true

                this.$http.post("auth/providers/add-tags", payload).then(() => {
                    this.$global.loading = false

                    this.tagModal = false

                    this.$store.dispatch("account/fetchTags")

                    this.getProviders()
                })
            }, 500)
        },
        unTagProviders() {
            let payload = {
                providerIds: this.providerIds,
                tagIds: this.selectedModalTags.map(tag => tag.id),
            }

            this.$global.loading = true

            this.$http.post("auth/providers/untag", payload).then(() => {
                this.$global.loading = false

                this.removeTagModal = false

                this.getProviders()
            })
        },
        isCampaignAvailable(code) {
            let available = false
            let contracts = this.account.current_contracts

            if (contracts.length) {
                contracts.forEach(contract => {
                    let module = contract.contract_offer.options.filter(option => option.code === code)

                    if (module.length) {
                        available = true
                    }
                })
            }
            return available
        },
        async getTagsFromProviders() {
            let providerIds = await this.getProviderIds()

            let payload = {
                providerIds: providerIds,
            }

            let res = await this.$http.post("auth/providers/tags", payload)

            this.$global.loading = false

            return res.body.data.tags
        },
        addTag(event) {
            // nécéssaire pour le cas ou on recherche un tag puis l'ajoute. Sans cette fonction vide,
            // le tag sélectionné est déselectionné lors du clique en dehors de l'input
            event.stopPropagation()
        },
        async prepareExport() {
            this.loadingExport = true

            let providerIds = await this.getProviderIds(true)

            let payload = {
                providerIds: providerIds,
            }

            let res = await this.$http.post("auth/providers/export/generate", payload)
            let filename = res.body.data.filename

            this.loadingExport = false

            let a = document.createElement("a")

            a.href = this.apiUrl + "/export-to-xls/" + filename
            a.click()
        },
        getProvidersCount() {
            this.$http.get("auth/account/providers-count").then((res) => {
                this.totalProviders = res.body.data.count
            })
        },
        getTisTypeLabel() {
            if (this.account.tis_type.code === 'DAHUB_QUEBEC') {
                return null
            }

            if(this.account.tis_type.code === "APIDAE") {
                return 'Apidae'
            } else if(this.account.tis_type.code === "TOURINSOFT") {
                return 'Tourinsoft'
            } else if(this.account.tis_type.code === "NO_SIT") {
                return 'un fichier excel'
            }
        },
    },
    computed: {
        ...mapState("providerFilter",
          ["search", "selectedCategories", "selectedWebFormStates", "selectedTags", "selectedCommunes",
              "selectedTourismSectors", 'emailSearch'],
        ),
        ...mapState("account", ["user", "account", "tags"]),
        isAccountConfigured() {
            return this.config.cgu !== null &&
              this.config.logo !== null &&
              this.config.organism !== null &&
              this.config.oneSender
        },
        isCmajAvailable() {
            return this.isCampaignAvailable("CMAJ")
        },
        isCadhAvailable() {
            return this.isCampaignAvailable("CADH")
        },
        hasCreateProviderModule() {
            if (this.account.current_contracts) {
                return this.account.current_contracts.filter(contract => contract.contract_offer.options.filter(option => {
                    return option.code === "SHEET_CREATION"
                }).length > 0).length > 0
            } else {
                return false
            }
        },
        deleteNumber() {
            return Math.max(this.selectedProviders.length - this.proConnexions.length, 0)
        },
        searchInProgress() {
            return (this.search !== "" && this.search !== null) || (this.emailSearch !== "" && this.emailSearch !== null)
              || this.selectedCategories.length > 0 || this.selectedCommunes.length > 0 || this.selectedTags.length > 0
              || this.selectedWebFormStates.length > 0
        },
    },
    watch: {
        options() {
            this.getProviders()
        },
        search() {
            this.options.page = 1
            this.getProviders()
        },
        emailSearch() {
            this.options.page = 1
            this.getProviders()
        },
        selectedCategories() {
            this.options.page = 1
            this.getProviders()
        },
        selectedCommunes() {
            this.options.page = 1
            this.getProviders()
        },
        selectedTourismSectors() {
            this.options.page = 1
            this.getProviders()
        },
        selectedTags() {
            this.options.page = 1
            this.getProviders()
        },
        selectedWebFormStates() {
            this.options.page = 1
            this.getProviders()
        },
        selectedProviders() {
            if (this.selectedProviders.length !== this.options.itemsPerPage) {
                this.selectAll = false
            }
        },
    },
    created() {
        this.getProviders()
        this.getProvidersCount()

        this.$store.dispatch("account/fetchContacts")

        this.config = this.account.configurations

        this.$global.$on("load-providers", () => {
            this.importDialog = false

            this.$store.dispatch("account/fetchTags")
            this.getProvidersCount()

            this.getProviders()
        })

        this.$global.$on("close-import", () => {
            this.importDialog = false
        })

        this.$global.$on("close-update-modal", () => {
            this.editContactModal = false
        })

        if (this.account.configurations.quebec) {
            this.headers.find(header => header.text === "Commune").text = "Municipalité"
        }
    },
    beforeDestroy() {
        this.$global.$off("load-providers")
        this.$global.$off("close-import")
        this.$global.$off("close-update-modal")
    },
}
</script>
